import { Mapper } from '../../../common/ddd/mapper.base';
import { formatDeviation } from '../../../common/utils/format-deviation.util';
import { formatDuration } from '../../../common/utils/format-duration.util';
import { ChallengeTimeInAppsAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-time-in-apps.aggregate-root';
import { GetAccountMetricsInsightsAveragesResponseDto } from '../../../interface/dtos/challenge-insights/get-account-metrics-insights-averages.response.dto';
import { MetricValueType } from '../../../interface/dtos/challenge-insights/metric-value-type';

export class ChallengeTimeInAppsAggregateRootMapper
  implements
    Omit<
      Mapper<
        ChallengeTimeInAppsAggregateRoot,
        GetAccountMetricsInsightsAveragesResponseDto
      >,
      'toDomain'
    >
{
  toResponse(
    entity: ChallengeTimeInAppsAggregateRoot
  ): GetAccountMetricsInsightsAveragesResponseDto {
    return ChallengeTimeInAppsAggregateRootMapper.toResponse(entity);
  }
  static toResponse(
    entity: ChallengeTimeInAppsAggregateRoot
  ): GetAccountMetricsInsightsAveragesResponseDto {
    const isUniqueUsers = entity.type === MetricValueType.UniqueUsers;

    return {
      deviation: `${formatDeviation(Math.round(entity.deviationPercentage))}`,
      beforeValue: Math.round(entity.beforeValue),
      afterValue: Math.round(entity.value),
      beforeFormattedValue:
        entity.type === MetricValueType.Interactions || isUniqueUsers
          ? String(Math.round(entity.beforeValue))
          : formatDuration(entity.beforeValue),
      afterFormattedValue:
        entity.type === MetricValueType.Interactions || isUniqueUsers
          ? String(Math.round(entity.value))
          : formatDuration(entity.value),
      averageDeviation: `${formatDeviation(
        Math.round(entity.averageDeviationPercentage)
      )}`,
      beforeAverage: Math.round(entity.beforeAverage),
      afterAverage: Math.round(entity.average),
      beforeFormattedAverage:
        entity.type === MetricValueType.Interactions || isUniqueUsers
          ? String(Math.round(entity.beforeAverage))
          : formatDuration(entity.beforeAverage),
      afterFormattedAverage:
        entity.type === MetricValueType.Interactions || isUniqueUsers
          ? String(Math.round(entity.average))
          : formatDuration(entity.average),
    };
  }
}
